import Vue from 'vue'
import Router from 'vue-router'
import ArticleList from '@/components/1st/ArticleList'
import Article from '@/components/1st/Article'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/ArticleList',
      name: 'ArticleList',
      component: ArticleList
    },
    {
      path: '/Article/:id',
      name: 'Article',
      component: Article
    },
    {
      path: '*',
      redirect: '/ArticleList'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/1st.js